const mixin = {
  data () {
    return {

    }
  },
  computed: {
    test1: () => 123
  },
  methods: {
    /**
     * 格式化时间
     * @param {string|number|object|Array} dateTime - 时间，可以是一个字符串、时间戳、表示时间的对象、Date对象或者******表示时间的数组
     * @param {string} [fmt] - 格式
     * @returns {string} 返回格式化后的日期时间，默认格式：2018年1月11日 15:00
     * @see [momentjs]{@tutorial http://momentjs.cn/}
     */
    formatDate (dateTime, fmt = 'YYYY年M月DD日 HH:mm:ss') {
      if (!dateTime) {
        return ''
      }
      return dateTime
    },
    PUSH (data) {
      this.$router.push(data)
    },
    REPLACE (data) {
      this.$router.replace(data);
    },
    GO (data) {
      this.$router.go(data)
    },
    loginOut () {
      localStorage.removeItem('userInfo')
      this.REPLACE({ name: 'login' })
      // window.location.href = "/"
    },
    typeStringToArry (string) {
      // 将两头有[]的字符串转为数组
      if (string && typeof string == 'string' && string.substr(0, 1) == '[' && string.substr(string.length - 1, 1) == ']') {
        if (string.substr(1, string.length - 2) != '') {
          string = string.substr(1, string.length - 2).split(',').map((item) => {
            if ((item.substr(0, 1) == "'" && item.substr(item.length - 1, 1) == "'") || (item.substr(0, 1) == '"' && item.substr(item.length - 1, 1) == '"')) {
              return item.substr(1, item.length - 2)
            }
            return item
          })
        } else {
          string = []
        }
        return string
      } else if (typeof string == 'object' && string != null) {
        return string
      }
      return []
    },
    decodeURL (url) {
      return decodeURIComponent(url || '')
    },
    encodeURL (url) {
      return encodeURIComponent(url)
    },
    getUrlFileName (fileUrl) {
      let str = fileUrl;
      str = str.substring(str.lastIndexOf("/") + 1);
      str = str.substring(0, str.lastIndexOf("."));
      return str;
    },
    // 数组对象排序 参数(排序数组，排序依据对象下标) 注意：下标以string类型传入
    sortByKey (array, key) {
      return array.sort(function (a, b) {
        var x = a[key];
        var y = b[key];
        return x < y ? -1 : x > y ? 1 : 0;
      });
    },
    // 手机号校验
    judgePhone (val = "") {
      let reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      // 可以为空
      return !val || reg.test(val)
    },
    // 处理时间显示
    handleTime (time) {
      return time ? this.moment(time).format("YYYY-MM-DD HH:mm:ss") : "N/A";
    },
    // 管理员权限
    adminShow () {
      return localStorage.getItem("userRoles") == 1;
    },
    // 门店权限
    shopShow () {
      return localStorage.getItem("userRoles") == 2;
    },
    // 金额显示
    handleMoney (val = 0) {
      return (val / 100).toFixed(2);
    }
  }
  // accDiv (arg1, arg2) {
  //   var t1 = 0, t2 = 0, r1, r2;
  //   try { t1 = arg1.toString().split(".")[1].length } catch (e) { }   //--小数点后的长度
  //   try { t2 = arg2.toString().split(".")[1].length } catch (e) { }  //--小数点后的长度
  //   with (Math) {
  //     r1 = Number(arg1.toString().replace(".", ""))  //--去除小数点变整数
  //     r2 = Number(arg2.toString().replace(".", ""))  //--去除小数点变整数
  //     return (r1 / r2) * pow(10, t2 - t1);   //---整数相除 在乘上10的平方  小数点的长度
  //   }
  // }
}
export default mixin
